import React from "react";
import { HiOutlinePencil } from "react-icons/hi";
import CustomPhoneInput from "../../common/CustomPhoneInput";

const PhoneNumberField = ({
  label = "Phone number",
  value = "",
  onChange = () => {},
  placeholder = "Enter phone number",
  country = "fr",
  disabled = true,
  showEdit = false,
  onEdit = () => {},
  editLabel = "Update mobile number",
  editAriaLabel = "Update mobile number",
  isEditDisabled = false,
  className = "",
}) => {
  return (
    /* All six mounts sit in a one-third / one-half grid cell, and the field
       shared one NON-wrapping line with the 202px whitespace-nowrap button. The
       button kept its size, so the input got the remainder — 79px at 375, 72px
       at 768, 201px at 1440 — while the number needs 207px. Only the display
       was clipped, never the value, so the user saw "+" or a number short of
       its last digit and could not check their own number.

       The row therefore wraps instead of squeezing (wrap or scroll, never
       shrink, cut or drop), same as viewpitches/PitchFilterPanel.js:84.
       min-w-[250px] does double duty: it is the wrap trigger — while the line
       fits 250 + 12 + 202 the two stay side by side, so at 2560 the field
       measures 574px before and after — and it is a floor, which 768px needs,
       because the three-column grid leaves the cell only ~203px there and even
       a field filling that cell stays short of 207px. As a floor it lets that
       one column grow to 250px (measured: 191px and still clipped when the
       floor is capped to the cell, 250px and complete without the cap). */
    <div className={`flex flex-wrap items-end gap-3 ${className}`}>
      <div className="flex-1 min-w-[250px]">
        <CustomPhoneInput
          label={label}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          country={country}
          disabled={disabled}
        />
      </div>
      {showEdit && (
        <button
          type="button"
          onClick={onEdit}
          disabled={isEditDisabled}
          className="flex mb-[18px] items-center gap-2 rounded-md border border-[#2283FF] bg-white px-3 py-2 text-sm font-medium text-[#2283FF] transition hover:bg-[#2283FF0D] disabled:cursor-not-allowed disabled:opacity-60 whitespace-nowrap
          
          "
          aria-label={editAriaLabel || editLabel}
        >
          <HiOutlinePencil className="h-4 w-4" />
          <span>{editLabel}</span>
        </button>
      )}
    </div>
  );
};

export default PhoneNumberField;
